// import ldr from "../../../icons/leadership.png";
import ldr from "../../../icons/festival/leader-board.webp";
import Header from "../../Questions/component/Header";
import style from "../css/Leadership.module.css";

import scienceImg from "../../../icons/coin.svg";
import male from "../../../icons/maleAvatar.png";
import female from "../../../icons/femaleAvatar.png";
import crown from "../../../icons/leaderboard-icon/crown.svg";
import rank1Badge from "../../../icons/leaderboard-icon/Group 1000004632.svg";
import rank2Badge from "../../../icons/leaderboard-icon/Group 1000004631.svg";
import rank3Badge from "../../../icons/leaderboard-icon/Group 1000004633.svg";

import { ErrorHandling } from "../../../State";
import UAParser from "ua-parser-js";
import { offerEvent, userLeaderboard } from "../../../utils/api";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Calendar,
  ChevronRight,
  Clock,
  Crown,
  Gift,
  GiftIcon,
  Users,
} from "lucide-react";

function Leadership() {
  const navigate = useNavigate();
  const fanduPoints = localStorage.getItem("userFanduPoints") || 0;
  const fanduUserId = localStorage.getItem("fanduUserId");

  let mId = localStorage.getItem("mId") || "2026";

  let uuid = localStorage.getItem("uuid");

  let session_id = localStorage.getItem("session_id");

  const offerRequestData = (eventMetaData) => {
    try {
      const parser = new UAParser();

      const result = parser.getResult();

      return {
        machine_id: mId || "",
        device_id: uuid || "",
        session_id: session_id || "",
        ip_address: localStorage.getItem("ip_address") || "",
        lat: "",
        lng: "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        deviceBrand: result?.device?.vendor || "Unknown",
        deviceModel: result?.device?.model || "Unknown",
        deviceType: result?.device?.type || "desktop",
        osName: result?.os?.name || "Unknown",
        osVersion: result?.os?.version || "Unknown",
        browserName: result?.browser?.name || "Unknown",
        browserVersion: result?.browser?.version || "Unknown",
        event_ts: Date.now().toString(),
        user_id: localStorage.getItem("userId") || "",
        ...eventMetaData,
      };
    } catch (error) {
      ErrorHandling("Unable to collect device information");

      return null;
    }
  };

  const avail = async (EventName, EventSubName, EventType, EventSubType) => {
    try {
      const requestData = offerRequestData({
        Event_Name: EventName,
        Event_Sub_Name: EventSubName,
        Event_Type: EventType,
        Event_Sub_Type: EventSubType,
      });

      if (!requestData) return;

      await offerEvent(requestData);
    } catch (error) {
      console.log("Offer Event Error:", error);
    }
  };

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        setLoading(true);

        const response = await userLeaderboard();

        if (response?.success && Array.isArray(response?.data)) {
          const formattedLeaderboard = response.data
            .sort(
              (a, b) =>
                Number(b.contest_score || 0) - Number(a.contest_score || 0),
            )
            .map((item, index) => ({
              id: item.id,
              userId: item.user_id,

              // Rank based on sorted position
              rank: index + 1,

              // API user name
              name: item.User?.name?.trim() || "Anonymous",

              // Contest leaderboard points
              points: Number(item.contest_score || 0),

              // Alternate avatar for now
              avatar: item.User.gender == "Female" ? female : male,

              isCurrentUser:
                String(item.user_id).trim() === String(fanduUserId).trim(),

              balance: item.balance,
              score: item.score,
              contestScore: item.contest_score,
            }));

          setLeaderboard(formattedLeaderboard);
        } else {
          ErrorHandling(response?.message || "Unable to fetch leaderboard.");

          setLeaderboard([]);
        }
      } catch (error) {
        console.error("Leaderboard API Error:", error);

        ErrorHandling(error?.message || "Unable to fetch leaderboard.");

        setLeaderboard([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, []);

  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);

  const topThree = leaderboard.slice(0, 3);
  const restPlayers = leaderboard.slice(3);

  useEffect(() => {
    avail(
      "Leaderboard_Screen",
      "Leaderboard_Screen",
      "Screen_Impression",
      "Page_Open",
    );
  }, []);

  return (
    <>
      <Header fanduPoints={fanduPoints} />
      <img src={ldr} style={{ width: "100%" }} />
      <div className={style.bottomSection}>
        {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "600",
          }}
        >
          <p>Live Contests</p>
          <span className={style.liveBadge}>Live</span>
        </div>
        <div className={style.contestScrollContainer}>
          <ContestCard
            title="Science Quiz"
            image={scienceImg}
            timeLeft="2 Days Left"
            players="350"
            days="3"
            winners="20"
            prize="₹500"
          />
          <ContestCard
            title="Science Quiz"
            image={scienceImg}
            timeLeft="2 Days Left"
            players="350"
            days="3"
            winners="20"
            prize="₹500"
            borderColor="#FFB800"
            backgroundColor="#FFF8DE"
            iconColor="#FFB800"
            arrowColor="#FFB800"
          />
          <ContestCard
            title="Science Quiz"
            image={scienceImg}
            timeLeft="2 Days Left"
            players="350"
            days="3"
            winners="20"
            prize="₹500"
            borderColor="#5116a3ff"
            backgroundColor="#f2edf6ff"
            iconColor="#5116a3ff"
            arrowColor="#5116a3ff"
          />
          <ContestCard
            title="Science Quiz"
            image={scienceImg}
            timeLeft="2 Days Left"
            players="350"
            days="3"
            winners="20"
            prize="₹500"
            borderColor="#da2222ff"
            backgroundColor="#fdf1f1ff"
            iconColor="#da2222ff"
            arrowColor="#da2222ff"
          />
        </div> */}
        {loading ? (
          <div className={style.loaderWrapper}>
            <div className={style.loader} />
          </div>
        ) : leaderboard.length === 0 ? (
          <div className={style.emptyLeaderboard}>
            <p>No leaderboard data available yet.</p>
          </div>
        ) : (
          <>
            <div className={`${style.topRankContainer} `}>
              {[topThree[1], topThree[0], topThree[2]]
                .filter(Boolean)
                .map((player) => (
                  <TopRankCard key={player.id || player.rank} player={player} />
                ))}
            </div>

            <div className={style.leaderList}>
              {restPlayers.map((player) => (
                <LeaderboardRow
                  key={player.id || player.rank}
                  player={player}
                />
              ))}
            </div>
          </>
        )}
        <div
          className={style.earnPtsContainer}
          onClick={() => {
            navigate("/janmashtmi-contest");
            avail("Quiz", "Leaderboard_Screen", "Click", "Questions");
          }}
        >
          <GiftIcon
            style={{
              color: "white",
              backgroundColor: "#3550DC",
              borderRadius: "50%",
              padding: "5px",
              width: "35px",
              height: "35px",
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              marginLeft: "-35px",
            }}
          >
            <p
              style={{
                color: "#3550DC",
                fontSize: "12px",
                fontWeight: "500",
              }}
            >
              Keep playing, keep earning!
            </p>
            <p style={{ color: "#050505", fontSize: "9px" }}>
              Climb the leaderboard and win exciting rewards.
            </p>
          </div>
          <ChevronRight style={{ color: "#3550DC" }} />
        </div>
      </div>
    </>
  );
}

export default Leadership;

const ContestCard = ({
  title,
  image,
  timeLeft,
  players,
  days,
  winners,
  prize,
  borderColor = "#0147EE",
  backgroundColor = "#F0F5FD",
  iconColor = "#F28C00",
  arrowColor = "#0147EE",
  onClick,
}) => {
  return (
    <div
      className={style.contestCard}
      style={{
        borderColor,
        backgroundColor,
      }}
      onClick={onClick}
    >
      <div className={style.contestHeader}>
        <div className={style.contestImage}>
          <img src={image} alt={title} />
        </div>

        <div className={style.contestInfo}>
          <h2>{title}</h2>
        </div>

        <ChevronRight className={style.arrow} style={{ color: arrowColor }} />
      </div>
      <div className={style.timeLeft}>
        <Clock color="green" className={style.icon} />
        <span>{timeLeft}</span>
      </div>

      <div className={style.divider} />

      <div className={style.contestStats}>
        <div className={style.stat}>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <Users style={{ color: iconColor }} className={style.icon} />
            <h5>{players}</h5>
          </div>
          <p>Players</p>
        </div>

        <div className={style.stat}>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <Calendar style={{ color: iconColor }} className={style.icon} />
            <h5>{days}</h5>
          </div>
          <p>Days</p>
        </div>

        <div className={style.stat}>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <Crown style={{ color: iconColor }} className={style.icon} />
            <h5>{winners}</h5>
          </div>
          <p>Winners</p>
        </div>

        <div className={style.stat}>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <Gift style={{ color: iconColor }} className={style.icon} />
            <span className={style.prizeLabel}>Prize</span>
          </div>
          <h5>{prize}</h5>
        </div>
      </div>
    </div>
  );
};

const TopRankCard = ({ player }) => {
  const rankStyle = {
    1: {
      background: "#FFF8DE",
      border: "#FFB800",
    },
    2: {
      background: "#F1F6FF",
      border: "#3776E8",
    },
    3: {
      background: "#FFF5EE",
      border: "#FFB899",
    },
  };

  return (
    <div
      className={style.rankCard}
      style={{
        background: rankStyle[player.rank].background,
        borderColor: rankStyle[player.rank].border,
        height: player.rank == 1 ? "145px" : "135px",
        marginTop: player.rank == 1 ? 0 : "10px",
      }}
    >
      {player.rank === 1 && (
        <img src={crown} className={style.crown} alt="Crown" />
      )}

      <img
        src={
          player.rank === 1
            ? rank1Badge
            : player.rank === 2
              ? rank2Badge
              : rank3Badge
        }
        className={style.rankBadge}
        alt={`Rank ${player.rank}`}
      />

      <img src={player.avatar} className={style.avatar} alt={player.name} />

      <div className={style.playerName}>{player.name}</div>

      <div className={style.points}>
        <img src={scienceImg} alt="Points" style={{ width: "14px" }} />

        {player.points}
      </div>
    </div>
  );
};

const LeaderboardRow = ({ player }) => {
  return (
    <div
      className={`${style.row} ${
        player.isCurrentUser ? style.currentUserRow : ""
      }`}
    >
      <div className={style.rankNumber}>{player.rank}.</div>

      <img
        src={player.avatar}
        className={style.smallAvatar}
        alt={player.name}
      />

      <div className={style.rowName}>
        {player.name}

        {player.isCurrentUser && <span className={style.youBadge}>You</span>}
      </div>

      <div className={style.rowPoints}>
        <img src={scienceImg} alt="points" />

        <span>{player.points}</span>
      </div>
    </div>
  );
};
